import { addHook, removeAllHooks, sanitize } from '../../utilities/dompurify';

const ALLOWED_TAGS = [
  'a',
  'b',
  'blockquote',
  'br',
  'caption',
  'code',
  'div',
  'em',
  'figcaption',
  'figure',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'nl',
  'ol',
  'p',
  'pre',
  'span',
  'strike',
  'strong',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'ul',
];

const ALLOWED_ATTR = [
  'class',
  'data-plyr-embed-id',
  'data-plyr-provider',
  'height',
  'href',
  'rel',
  'src',
  'target',
  'width',
  'style', // Note (LiamBorner): I discussed this with Bill before adding this attribute it. I am using it for the team member action view to decorate the underline attribute
];

export function sanitizeContent(dirtyContent: string): string {
  return sanitize(dirtyContent, {
    ALLOWED_ATTR,
    ALLOWED_TAGS,
  });
}

export function sanitizeContentAndForceExternalLinks(dirtyContent: string): string {
  // This function is pulled from here: https://github.com/cure53/DOMPurify/issues/317 - and let's us add _blank and nooopener to the links
  addHook('afterSanitizeAttributes', (node) => {
    // set all elements owning target to target=_blank
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  });

  const sanitizedContent = sanitize(dirtyContent);

  // We aren't sure whether the hook we added above will linger around, so just being safe and calling the DOMPurify removeAllHooks() method
  removeAllHooks();

  return sanitizedContent;
}
